<template>
  <div class="flex items-center h-full py-1">
    <div class="flex-1 min-w-0 leading-tight">
      <div class="sensitive font-medium text-gray-900 truncate">{{ titleCase(patientName) }}</div>
      <div class="text-xs truncate">
        <span class="sensitive text-blue-600 font-mono">{{ params.data?.patient_identifier }}</span>
        <template v-if="formattedDob">
          <span class="text-gray-400"> · </span>
          <span class="sensitive text-gray-500">{{ formattedDob }}</span>
        </template>
      </div>
      <div v-if="payerName || contractType || hasFlags" class="flex flex-wrap items-center gap-1 text-xs min-w-0" :title="payerTooltip">
        <span v-if="payerName" class="sensitive text-gray-700 truncate">{{ payerName }}</span>
        <span v-if="contractType" class="shrink-0 px-1 bg-purple-50 text-purple-700 rounded font-medium">{{ contractType }}</span>
        <RiskAcuityBadge v-if="hasFlags" :patient="params.data" />
      </div>
    </div>
  </div>
</template>

<script>
import RiskAcuityBadge from '@/components/Care_Management/Custom_Cell_Renderers/RiskAcuityBadge.vue';

export default {
  name: 'Quality_PatientPayerCell',
  components: { RiskAcuityBadge },
  props: ['params'],
  computed: {
    hasFlags() {
      return Array.isArray(this.params.data?.flags) && this.params.data.flags.length > 0;
    },
    formattedDob() {
      const dob = this.params.data?.bene_dob;
      if (!dob) return null;
      const parts = String(dob).substring(0, 10).split('-');
      if (parts.length !== 3) return dob;
      return `${parts[1]}/${parts[2]}/${parts[0]}`;
    },
    patientName() {
      const data = this.params.data || {};
      if (data.patient_name && data.patient_name !== 'Unknown') {
        return data.patient_name;
      }
      const first = data.bene_first_name || '';
      const last = data.bene_last_name || '';
      if (last || first) {
        return `${last}, ${first}`.replace(/^, |, $/g, '');
      }
      return 'Unknown';
    },
    payerName() {
      return this.params.data?.payer_name;
    },
    contractType() {
      return this.params.data?.contract_type;
    },
    payerTooltip() {
      const d = this.params.data || {};
      return [d.payer_name, d.contract_type, d.contract_name, d.contract_state].filter(Boolean).join(' — ');
    }
  },
  methods: {
    titleCase(str) {
      if (!str) return str;
      const keep = new Set(['II', 'III', 'IV', 'JR', 'SR', 'MD', 'DO', 'NP', 'PA', 'RN']);
      return str.split(/\s+/).map(w => {
        const clean = w.replace(/[,.]$/, '');
        if (keep.has(clean.toUpperCase())) return w.toUpperCase();
        return w.toLowerCase().replace(/^\w/, c => c.toUpperCase());
      }).join(' ');
    }
  }
};
</script>
